import { useTranslation } from 'react-i18next';
import React from 'react';
import { connect } from 'react-redux';

import { AppDispatch, RootState } from '../../../store/store';
import { UUID } from '../../../types/standard';
import Button from '../../common/Buttons/Button/Button';
import Loading from '../../common/Loading/Loading';
import Modal from '../../common/Modal/Modal';
import styles from '../changeActions.module.scss';
import { ReactComponent as IconTrash } from '../../../assets/moreMenu/trash.svg';
import ButtonsGroup from '../../common/Buttons/ButtonsGroup/ButtonsGroup';
import renderWhen from '../../../helpers/renderWhen';

import { User } from '../../../types/users/users';

import {
  selectDeleteMiembro,
  selectDeleteMiembroActive,
  selectDeleteMiembroLoading,
} from '../../../store/miembros/selectors';
import {
  hide,
  del as deleteMiembro,
} from '../../../store/miembros/deleteMiembroModule';

interface DeleteMiembroProps {
  user: User | null;
  active: boolean;
  loading: boolean;
  closeModal: () => void;
  deleteMiembro: (id: UUID | undefined) => void;
}

const DeleteMiembro: React.FC<DeleteMiembroProps> = ({
  user,
  active,
  loading,
  closeModal,
  deleteMiembro,
}) => {
  const { t } = useTranslation();
  // 'active' controls if the modal is open or close
  if (!active) return null;
  return (
    <>
      {user && (
        <Modal closeModal={closeModal}>
          <div className={styles.container}>
            <h1 className={styles.title}>
              <IconTrash className={`${styles.icon} ${styles.isIconTrash}`} />
              {t(
                'ComponentsPopupActionsDeleteMiembroDeleteMiembroEliminarMiembroA',
              )}
            </h1>
            <p className={styles.description}>
              {t(
                'ComponentsPopupActionsDeleteMiembroDeleteMiembroEstasSeguroDeQuererEliminarElMiembroA',
              )}
            </p>
            <div className={styles.appointmentWrapper}>
              <div className={styles.description}>
                <p>
                  <span className={styles.appointmentSection}>
                    {t(
                      'ComponentsPopupActionsDeleteMiembroDeleteMiembroNombre',
                    )}
                    :
                  </span>{' '}
                  {user.nombre} {user.apellido1} {user.apellido2}
                </p>
              </div>
            </div>
            <ButtonsGroup variant="center">
              <Button type="button" variant="negative" onClick={closeModal}>
                {t('CommonCancelar')}
              </Button>
              {user.id && (
                <Button
                  variant="positive"
                  onClick={() => {
                    deleteMiembro(user.id);
                    closeModal();
                  }}
                  data-testid="submit_button"
                >
                  {t('CommonEliminar')}
                </Button>
              )}
            </ButtonsGroup>
            {loading && <Loading />}
          </div>
        </Modal>
      )}
    </>
  );
};

const ConnectedDeleteMiembro = connect(
  (state: RootState) => ({
    user: selectDeleteMiembro(state),
    active: selectDeleteMiembroActive(state),
    loading: selectDeleteMiembroLoading(state),
  }),
  (dispatch: AppDispatch) => ({
    deleteMiembro: (payload: UUID | undefined) =>
      dispatch(deleteMiembro(payload)),
    closeModal: () => dispatch(hide()),
  }),
)(DeleteMiembro);

export default renderWhen(ConnectedDeleteMiembro, selectDeleteMiembroActive);
